<div>
  <div class="mx-auto" *ngIf="loadingEnfoque">
    <div class="d-flex justify-content-center">
      <strong>{{ inputMessageModal }}</strong>
    </div>
    <div class="d-flex justify-content-center">
      <strong>Espere un momento mientras se carga la información ... 
        <div class="spinner-border" role="status"></div>
      </strong>
    </div>
  </div>

  <div *ngIf="!loadingEnfoque">
    <div class="row">
      <div class="col-9">
      </div>
      <div class="col-3">
        <input type="text" [ngModel]="searchT" [class]="'form-control'" placeholder="Buscar..."
          (keyup)="changeSearch($event)">
      </div>
    </div>
    <table datatable [dtTrigger]="dtTriggerEnfoque" class="table table-striped table-responsive">
      <thead>
        <tr>
          <th>Acciones</th>
          <th>Nombre Enfoque</th>
          <th>Estado</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let enfoque of enfoqueMantenedor | paginate: {itemsPerPage : 10, currentPage: pageActualEnfoque}">
          <td class="td-centered">
            <!-- aca -->
            <span (click)="onCreateEnfoque(categoriaModal,'Editar', enfoque)" [ngbTooltip]="'Editar'">
              <img [src]="'assets/icons/pencil.svg'" />
            </span>
            <span (click)="openDeleteModalEnfoque(confirmationModal, enfoque)" [ngbTooltip]="'Eliminar'">
              <img [src]="'assets/icons/trashcan.svg'" />
            </span>
          </td>
          <td class="td-centered">{{enfoque.enfoqueDescription}}</td>
          <td class="td-centered">{{getEstadoLabel(enfoque.status)}}</td>
        </tr>
      </tbody>
    </table>
    <pagination-controls (pageChange)="pageActualEnfoque = $event" class="pagination"></pagination-controls>
  </div>
</div>

<ng-template #confirmationModal let-modal>
  <app-confirmation-modal [modal]="modal" [tittle]="confirmationModalTittle" [message]="confirmationModalMessage"
    [hasComment]="confirmationModalHasComment" [hasOptions]="confirmationModalHasOptions"
    [isCommentObligatory]="confirmationModalisCommentObligatory" [optionLabel]="confirmationModalOptionLabel"
    [options]="confirmationModalOptions" (accept)="confirmationModalAccept($event.comment, $event.option)">
  </app-confirmation-modal>
</ng-template>
<!-- aca -->
<ng-template #categoriaModal let-modal>
  <app-enfoque-modal [modalCategoria]="modal" [mode]="creationMode" [categoria]="enfoqueSelected"
    (createEdit)="refreshEnfoqueCreateOrUpdate($event)">
  </app-enfoque-modal>
</ng-template>
